export const handleHistoryView = (car) => {
    const historySave = JSON.parse(localStorage.getItem("history")) || [];
    const history = historySave.filter((e) => e.name !== car.name);
    history &&
        localStorage.setItem("history", JSON.stringify([...history, car]));
};
